import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, EventEmitter, Component, Input, Output, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { MediaCategory } from '../../models/media/media-category.model';
import {
  ViewerTemplateCategory,
  ViewerTemplate,
  SaveViewerTemplateRequest,
} from '../../models/media/vet-sale-template.model';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { VetSettingsFacade } from '../../shared-new/store/vet-settings/vet-settings.facade';
import { MediaCategoryDataSource } from '../media-category/media-category-datasource';
@Component({
  selector: 'app-viewer-template-categories-popup',
  templateUrl: './viewer-template-categories-popup.component.html',
  styleUrls: ['./viewer-template-categories-popup.component.scss'],
})
export class ViewerTemplateCategoriesPopupComponent
  extends BaseUnsubscribeComponent
  implements OnInit
{
  mediaCategories$ = this.vetSettingFacade.mediaCategories$;
  @Input() public data: any;
  @Input() public isSelectionMode: boolean = true;
  @Input() public defaultSelectedMediaCategoryIds?: number[] = [];
  @Output() public selectedIds = new EventEmitter<number[]>();
  form: FormGroup;
  @ViewChild(MatSort) sort: MatSort;
  public dataSource: MediaCategoryDataSource;
  public viewerTemplate: ViewerTemplate;
  public selection = new SelectionModel<MediaCategory>(true, []);
  //selectedTemplateIds: Set<number> = new Set<number>();
  public isLoader: boolean = false;
  public selectSaveViewerTemplates$ =
    this.vetSettingFacade.selectSaveViewerTemplates$;
  @ViewChild('table1') dataTable: MatTable<any>;
  //@ViewChild("categorySort") sort: MatSort;
  public displayedColumns$ = new BehaviorSubject([    
    'drag',
    /*'select',    */
    'mediaCategoryName',
    'mediaGroup',
    'leftOrRight',
    'nameVariationCount',
    'moveup',
    'movedown',
  ]);
  private sortOrderSubject$ = new BehaviorSubject<'ASC' | 'DESC'>('ASC');
  dragStartIndex: number | null = null;
  newLocation: number = null;

  constructor(
    public readonly modal: NgbActiveModal,
    private readonly vetSettingFacade: VetSettingsFacade,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    super();
    this.form = this.formBuilder.group({
      viewerTemplateId: [0],
      //viewerTemplateId: [0],
      name: ['', Validators.required],
      isActive: [true],
      description: [''],
      isDefault: [true],
    });
  }

  moveItem(event: MouseEvent, fromIndex: number, toIndex: number) {
    event.preventDefault();

    
    this.newLocation = toIndex;
    moveItemInArray(this.dataSource.data, fromIndex, toIndex);
    this.dataSource.data = [...this.dataSource.data];
    this.dragStartIndex = null;
    this.dataTable.renderRows();
    this.form.markAsDirty();
    this.cdr.detectChanges();
  }
  
  drop(event: CdkDragDrop<MediaCategory[]>) {
    this.newLocation = event.currentIndex;
    moveItemInArray(
      event.container.data,
      event.previousIndex,
      event.currentIndex
    );
    this.dataSource.data = [...this.dataSource.data];
    this.dragStartIndex = null;
    this.dataTable.renderRows();
    this.form.markAsDirty();
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.isLoader = true;
    
    this.vetSettingFacade.loadMediaCategories(
      this.data?.template.viewerTemplateId
      //this.data?.template.viewerTemplateId
    );
    this.attachEvents();
    this.viewerTemplate = this.data?.template;
    this.form.patchValue(this.viewerTemplate);
  }
  public closePopup(): void {
    this.modal.close(JSON.stringify(this.data));
  }
  public saveViewerTemplate() {    
    //this.selectedTemplateIds.add(this.selection.selected.map((x) => x.id));
    //let data = this.dataSource.data.filter(f => f.hasSaleTemplates);//.filter(obj => {
    
    //return data.every((type: any) => selected.has(type.notificationTypeId));
      //return Object.keys(this.selection.selected).every(propertyName => obj[propertyName] === this.selection.selected);
    //});;

    if (this.form.valid) {
      const viewerTemplate: ViewerTemplate = this.form.value;
      const viewerTemplateCategories: ViewerTemplateCategory[] = this.dataSource.data?.map(
        (x, i) => {
          return {
            mediaCategoryId: x.id,
            sortOrder: i + 1,
            createdBy: 0,
            createdDate: new Date(),
            viewerTemplateId: viewerTemplate.viewerTemplateId,
            viewerTemplateCategoryId: 0,
          };
        }
      );
      const template: SaveViewerTemplateRequest = {
        viewerTemplate: viewerTemplate,
        viewerTemplateCategories: viewerTemplateCategories,
        isUpdateOnlyDefault: false // it will be always false
      };
      //console.log(data)
      //console.log(viewerTemplateCategories)
      this.isLoader = true;
      this.vetSettingFacade.saveViewerTemplate(template);
    }
  }
  public onTableScroll(): void {
    this.dataSource.onScroll();
  }
  private attachEvents() {
    this.mediaCategories$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.isLoader = false;
        this.dataSource = new MediaCategoryDataSource(response, this.sort);
        
        this.defaultSelectedMediaCategoryIds = [];
        this.defaultSelectedMediaCategoryIds = this.dataSource.data.filter(x => x.hasSaleTemplates).map(function (i) {
          return i.id;
        });        
      });
    this.selectSaveViewerTemplates$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        if (response) {
          this.isLoader = false;
          this.vetSettingFacade.handleClearState();
          this.closePopup();
        }
      });
  }
  public IsDisableSend(): boolean {
    const numSelected = this.selection.selected.length;
    return !(numSelected > 0);
  }
  public sortTable(sortBy: keyof MediaCategory): void {
    const currentOrder = this.sortOrderSubject$.value;
    this.sortOrderSubject$.next(currentOrder === 'ASC' ? 'DESC' : 'ASC');
    this.compare(sortBy);
  }

  private compare(keySorted: keyof MediaCategory): void {
    const categories = this.dataSource.data;

    categories.sort((a, b) =>
      this.sortOrderSubject$.value === 'ASC'
        ? this.sortValuesByName(a, b, keySorted)
        : this.sortValuesByName(b, a, keySorted) // Reverse order for DESC
    );

    this.dataSource.data = categories; // Update the data source
  }
  private sortValuesByName(
    a: MediaCategory,
    b: MediaCategory,
    keySorted: keyof MediaCategory
  ): number {
    const aValue = a[keySorted] || '';
    const bValue = b[keySorted] || '';

    return aValue.toString().localeCompare(bValue.toString(), navigator.languages[0] || navigator.language, {
      numeric: true,
      ignorePunctuation: true,
    });
  }
}
